import { gql } from "@apollo/client";

export const creatorRewardRecord = gql`
    query creatorRewardRecord($lensId: ID!) {
        creatorRewardRecord(input: { lensId: $lensId }) {
            postUU
            rewardEligibility
        }
    }
`;
